:host {
  display: block;
  cursor: pointer;
}

button,
a {
  display: flex;
  align-items: center;
  inline-size: var(--button-width, fit-content);
  block-size: 100%;
  padding: var(--button-padding, var(--cxs-spacer-s) var(--cxs-spacer-m));
  border: 0;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  text-decoration: none;
  cursor: pointer;

  &:focus {
    outline: 2px solid var(--cxsContent_FocusColor);;
    outline-offset: var(--cxs-spacer-xxs);
  }

  // Undo above styles when focus was received via mouse click or touch
  &:focus:not(:focus-visible) {
    outline: 0;
  }

  &.transparent {
    padding: 0;
    border: 0;
    background-color: transparent;
    color: inherit;
  }

  &.icon {
    margin: 0;
    background: none;
  }

}
